/* eslint-disable import/no-duplicates */

const LandingPageData = {
  copyRight: `Copyright © ${new Date().getFullYear()} All rights reserved`,
};

 
export default LandingPageData;
